const accessPremises = {

    PREMISE_LIST: { name: 'Premise', path: '/premise-list' },
    PREMISE_DEEP_DIVE: { name: 'Premise Deep Dive', path: '/premise-deep-dive' },
    PREMISE_DETAILS: { name: 'Premise Details', path: '/premise-details' },
    ADD_PREMISE: { name: 'Add Premise', path: '/create-premise' },
    UPDATE_PREMISE: { name: 'Update Premise', path: '/edit-premise' },
    DELETE_PREMISE: { name: 'Delete Premise', path: '/delete-premise' },

    PREMISE_MANAGE: { name: 'Manage Premise', path: '/manage-premise' },
    PREMISE_HIERARCHY: { name: 'Premise Hierarchy', path: '/premise-hierarchy' },
    ASSIGN_UNIT: { name: 'Assign Unit', path: '/assign-unit' },
    UNIT_DETAILS: { name: 'Unit Details', path: '/unit-details' },
    UPDATE_OWNER: { name: 'Update Owner', path: '/edit-owner' },
    UPDATE_TENANT: { name: 'Update Tenant', path: '/edit-tenant' },
    VACATE_UNIT: { name: 'Vacate Unit', path: '/vacate-unit' },

    GATE_LIST: { name: 'Gate', path: '/gate-list' },
    ADD_GATE: { name: 'Add Gate', path: '/create-gate' },
    UPDATE_GATE: { name: 'Update Gate', path: '/edit-gate' },
    DELETE_GATE: { name: 'Delete Gate', path: '/delete-gate' },

    PARKING_LIST: { name: 'Parking', path: '/parking-list' },
    ADD_PARKING: { name: 'Add Parking', path: '/create-parking' },
    UPDATE_PARKING: { name: 'Update Parking', path: '/edit-parking' },
    DELETE_PARKING: { name: 'Delete Parking', path: '/delete-parking' },

    VEHICLE_LIST: { name: 'Vehicle', path: '/vehicle-list' },
    ADD_VEHICLE: { name: 'Add Vehicle', path: '/create-vehicle' },
    UPDATE_VEHICLE: { name: 'Update Vehicle', path: '/edit-vehicle' },
    DELETE_VEHICLE: { name: 'Delete Vehicle', path: '/delete-vehicle' },

    RULE_LIST: { name: 'Rule', path: '/rule-list' },
    ADD_RULE: { name: 'Add Rule', path: '/create-rule' },
    UPDATE_RULE: { name: 'Update Rule', path: '/edit-rule' },
    DELETE_RULE: { name: 'Delete Rule', path: '/delete-rule' },
    RULE_DETAILS: { name: 'Rule Details', path: '/rule-details' },

    VENDOR_LIST: { name: 'Vendor', path: '/vendor-list' },
    ADD_VENDOR: { name: 'Add Vendor', path: '/create-vendor' },
    UPDATE_VENDOR: { name: 'Update Vendor', path: '/edit-vendor' },
    DELETE_VENDOR: { name: 'Delete Vendor', path: '/delete-vendor' },

    PROPERTY: { name: 'Property', path: '/property' },
    PREMISES_AND_LOGS: { name: 'Premises & Logs', path: '/premises-and-logs' },

}

export default accessPremises;